/**
 * Masque les produits avec le metafield `custom.isDraft` sur la prod.
 * Sur Netlify staging : définir `GATSBY_DEPLOY_CONTEXT=staging`.
 * Sur la prod : `GATSBY_DEPLOY_CONTEXT=production` (ou laisser vide + build production).
 */
export function shouldHideDraftProducts(): boolean {
  const deployContext = process.env.GATSBY_DEPLOY_CONTEXT?.trim().toLowerCase();
  if (deployContext === `staging` || deployContext === `development`) return false;
  if (deployContext === `production`) return true;
  return process.env.NODE_ENV === `production`;
}
